import { kBiFieldTypeLabels } from '@euler/app/components/message/widgets/bi-upload/functions/biUploadLabels';
import { BiCatalogField } from '@euler/model/bi/catalog';
import { BiFieldRole, BiFieldType } from '@euler/model/bi/result';

/** A field's role and type in two words, e.g. `数值 · 数字`. */
export function biFieldKindText(field: BiCatalogField): string {
  const role =
    field.role === BiFieldRole.Measure
      ? '数值'
      : field.type === BiFieldType.Date || field.type === BiFieldType.Datetime
      ? '时间'
      : '分类';
  return `${role} · ${kBiFieldTypeLabels[field.type]}`;
}
